// Zentrale Prüfung der "prefers-reduced-motion"-Einstellung des Nutzers.
// Animations-/WebGL-Komponenten nutzen dies, um schwere Loops abzuschalten.
export function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
